export const REPLY_DISPOSITIONS = [
  {
    value: 'BUG',
    label: 'Bug',
    description: 'Chronos miscalculated or displayed incorrect data (e.g., incorrect ARR variance).',
  },
  {
    value: 'SOP_SYNC_ISSUE',
    label: 'SOP Sync Issue',
    description: 'A rule was updated in the SOP, but Chronos is still enforcing the old threshold or logic.',
  },
  {
    value: 'COVERAGE_GAP',
    label: 'Coverage Gap',
    description: "A reviewer identified a check that hasn't been implemented in Chronos yet.",
  },
  {
    value: 'SOP_DISPUTE',
    label: 'SOP Dispute',
    description: 'The reviewer applied a different rule interpretation than what Chronos was built against — not a defect, just a difference in approach.',
  },
  {
    value: 'NOT_AN_ISSUE',
    label: 'Not an Issue',
    description: 'After review, Chronos output was confirmed to be correct — no changes needed.',
  },
];

const LEGACY_DISPOSITION_LABELS = {
  IS_AN_ISSUE: 'Is an issue',
};

const ACTIONABLE_DISPOSITIONS = new Set([
  'BUG',
  'SOP_SYNC_ISSUE',
  'COVERAGE_GAP',
  'SOP_DISPUTE',
  'IS_AN_ISSUE',
]);

export const getReplyDisposition = (value) =>
  REPLY_DISPOSITIONS.find((disposition) => disposition.value === value);

export const getReplyDispositionLabel = (value) =>
  getReplyDisposition(value)?.label || LEGACY_DISPOSITION_LABELS[value] || value || '';

export const getReplyDispositionDescription = (value) =>
  getReplyDisposition(value)?.description || '';

export const isActionableReplyDisposition = (value) =>
  ACTIONABLE_DISPOSITIONS.has(value);

export const getFeedbackStatus = (feedback) => {
  if (!feedback) return 'Open';
  if (feedback.feedbackType === 'AGREE') return 'Resolved';
  if (feedback.replyDisposition === 'NOT_AN_ISSUE') return 'Resolved';
  if (isActionableReplyDisposition(feedback.replyDisposition) && feedback.resolvedAt) {
    return 'Resolved';
  }
  return 'Open';
};

export const getReplyDispositionBadgeColor = (value) => {
  if (value === 'NOT_AN_ISSUE') return 'blue';
  if (value === 'SOP_SYNC_ISSUE' || value === 'COVERAGE_GAP') return 'severity-medium';
  return 'red';
};

export const getSimTicketUrlError = (value) => {
  const trimmedValue = value.trim();
  if (!trimmedValue) return null;

  if (!/^https:\/\/[^/\\?#]/i.test(trimmedValue)) {
    return 'Enter a valid https://t.corp.amazon.com/ SIM-T URL.';
  }

  try {
    const url = new URL(trimmedValue);
    if (
      trimmedValue.length > 2048 ||
      url.protocol !== 'https:' ||
      url.hostname !== 't.corp.amazon.com' ||
      url.port ||
      url.username ||
      url.password
    ) {
      return 'Enter a valid https://t.corp.amazon.com/ SIM-T URL.';
    }
  } catch (error) {
    return 'Enter a valid https://t.corp.amazon.com/ SIM-T URL.';
  }

  return null;
};
